//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import {
  BatchUpdateModerationStatusRequest,
  RejectModerationMediaRequest,
  RejectionReasonsResponse,
} from '@apis/moderation/moderationApiModel';
import { serializedGatewayFetch } from '@utils/sessionFetch';
import { ISerializedResponse } from '@utils/types/SerializedResponse';

const MODERATION_BASE = '/api/v1/moderation';
const MANUAL_MODERATION_BASE = '/api/v1/manual-moderation';

const moderationGatewayFetch = (
  endpoint: string,
  init?: RequestInit,
): Promise<ISerializedResponse> => {
  return serializedGatewayFetch(
    'moderation_gateway',
    `${MODERATION_BASE}${endpoint}`,
    init,
  );
};

const manualModerationGatewayFetch = (
  endpoint: string,
  init?: RequestInit,
): Promise<ISerializedResponse> => {
  return serializedGatewayFetch(
    'moderation_gateway',
    `${MANUAL_MODERATION_BASE}${endpoint}`,
    init,
  );
};

export const getRejectionReasons = async (
  init?: RequestInit,
): Promise<RejectionReasonsResponse> => {
  const response = await manualModerationGatewayFetch('/rejection-reasons', {
    ...init,
    method: 'GET',
  });

  return response.json<RejectionReasonsResponse>();
};

export const rejectModerationMedia = async (
  req: RejectModerationMediaRequest,
  init?: RequestInit,
): Promise<void> => {
  await manualModerationGatewayFetch('/shared-media/reject', {
    ...init,
    method: 'PATCH',
    body: JSON.stringify(req),
  });
};

/**
 * Batch update moderation status for content items.
 *
 * PATCH /api/v1/moderation/status
 *
 * Returns 204 No Content on success.
 */
export const batchUpdateModerationStatus = async (
  req: BatchUpdateModerationStatusRequest,
  init?: RequestInit,
): Promise<void> => {
  await moderationGatewayFetch('/status', {
    ...init,
    method: 'PATCH',
    body: JSON.stringify(req),
  });
};
